import angular from 'angular'

import { ensureIconBaseClass } from '../vd-icon/vd-icon.utility'

/**
 * Directive for vdInputSymbol. Allows the user to add either an icon or symbol to an input field
 */
class VdInputSymbol {
  constructor() {
    this.restrict = 'A'
  }

  link(scope, $element, attrs) {
    let appendElement

    attrs.$observe('vdInputSymbol', buildInputSymbol)

    function buildInputSymbol() {
      const options = scope.$eval(attrs.vdInputSymbol)

      if (!options) {
        return
      }

      // Ensure only one symbol exists
      if (appendElement) {
        appendElement.remove()
      }

      let template

      // Check that alignment is set, otherwise default to left
      const align = options.align || 'left'

      if (options.icon) {
        $element.addClass(`vd-input--icon-${align}`)
        template = `<i class="${ensureIconBaseClass(
          options.icon
        )} vd-input-icon vd-input-icon--${align}"></i>`
      } else {
        const symbolOffset = 2
        const symbolPadding =
          options.symbol.replace(' ', '').length + symbolOffset

        $element.attr('style', `padding-${align}: ${symbolPadding}ch`)
        template = `<div class="vd-input-icon vd-input-icon--${align} vd-input-symbol">${options.symbol}</div>`
      }

      appendElement = angular.element(template)

      // Add the element
      $element.after(appendElement)
    }
  }
}

export default VdInputSymbol
